import React, { ReactNode } from 'react';
import _ from 'lodash';
import { connect, ConnectedProps } from 'react-redux';
import CookieBanner from 'client/components/banner/CookieBanner';
import FullFooter from 'client/components/footer/full';
import { fetchConfiguration } from 'client/actions/enterprise/user';
import { fetchContentfulEntriesByTypeAndMerge } from 'client/actions/contentful';
import { fetchMembers } from 'client/actions/members';
import { fetchUser } from 'client/actions/user';
import { isProvisionedForBrand } from 'routes/join/utils';

import 'client/styles/common.scss';
import 'client/styles/account.scss';

const mapStateToProps = ({ user, brand }) => ({
  brand,
  isLoggedIn: _.get(user, 'isLoggedIn', false),
  isProvisioned: isProvisionedForBrand(user, brand),
  user_id: _.get(user, 'oid', null),
});

const connector = connect(mapStateToProps, {});
type PropsFromRedux = ConnectedProps<typeof connector>;

type Props = PropsFromRedux & {
  children: ReactNode;
};

class JoinEnterpriseApp extends React.Component<Props> {
  static async fetchData({
    dispatch,
    getState,
  }: {
    dispatch: (action: any) => any;
    getState: () => Record<string, any>;
  }) {
    const { brand } = getState();

    await Promise.all([
      dispatch(fetchMembers()),
      dispatch(fetchUser()),
      dispatch(fetchConfiguration()),
      dispatch(
        fetchContentfulEntriesByTypeAndMerge(
          'landing-medicaid',
          { 'fields.key[in]': `join-${brand},join-default` },
          'join-default',
          'joinLandingPage',
        ),
      ),
    ]);
  }

  override render() {
    return (
      <div id="main-content">
        {React.isValidElement(this.props.children)
          ? React.cloneElement(React.Children.only(this.props.children), this.props)
          : null}
        <CookieBanner />
        <FullFooter showCoveredCaliforniaDisclaimer={false} />
      </div>
    );
  }
}

export default connector(JoinEnterpriseApp);
